"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceAll = exports.validateAndGetArray = exports.validateAndGetObject = exports.getFormValue = exports.patchFormValues = void 0;
var formstate_1 = require("formstate");
var lodash_1 = require("lodash");
var patchFormValues = function (form, object) {
    var obj = (0, lodash_1.cloneDeep)(object);
    Object.keys(obj).map(function (key) {
        if (form.$[key]) {
            form.$[key].onChange(obj[key]);
        }
    });
};
exports.patchFormValues = patchFormValues;
var getFormValue = function (form) {
    var returnedValue = {};
    Object.keys(form.$).map(function (key) {
        if (form.$[key] instanceof formstate_1.FormState) {
            returnedValue[key] = (0, exports.getFormValue)(form.$[key]);
        }
        else {
            returnedValue[key] = form.$[key].value;
        }
    });
    return returnedValue;
};
exports.getFormValue = getFormValue;
var validateAndGetObject = function (entity, keyMap) {
    var value = Object.assign({}, entity);
    keyMap.split('.').map(function (key) {
        value = value && value[key];
    });
    return value;
};
exports.validateAndGetObject = validateAndGetObject;
var validateAndGetArray = function (entity, keyMap) {
    var value = Object.assign({}, entity);
    keyMap.split('.').map(function (key) {
        value = value && value[key];
    });
    if (value) {
        if (value.length > 0) {
            return value;
        }
    }
    return [];
};
exports.validateAndGetArray = validateAndGetArray;
var replaceAll = function (value, replaceValue, replaceWith) {
    var newValue = value;
    while (newValue.includes(replaceValue)) {
        newValue = newValue.replace(replaceValue, replaceWith);
    }
    return newValue;
};
exports.replaceAll = replaceAll;
